import API_BASE_URL from './apiConfig';
import { getAuthHeaders } from './authApi';

const headers = () => ({ 'Content-Type': 'application/json', ...getAuthHeaders() });

export const getYearCoverage = async (year) => {
  const response = await fetch(`${API_BASE_URL}/im/coverage/year?year=${year}`, { headers: headers() });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getMonthCoverage = async (year, month) => {
  const response = await fetch(`${API_BASE_URL}/im/coverage/month?year=${year}&month=${month}`, { headers: headers() });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};
